export function PromoLine({ promoline }) {
  if (!promoline) return null
  return (
    <p
      style={`--bg-color:${promoline.backgroundColor?.value};--fg-color:${promoline.foregroundColor?.value}`}
      className="paragraph-sm w-fit -rotate-1 whitespace-nowrap bg-[--bg-color] px-2 py-1 font-bold text-[--fg-color] sm:group-hover/card:animate-wiggle"
    >
      {promoline.title}
    </p>
  )
}
